import axios from "axios";
import { VFUN } from "../utils/config/request";

export const BASE_PATH = process.env.REACT_APP_VFUN_API_DNS;
export const POST_GET_MEMBERINFO = `${BASE_PATH}/vfun/member_info`;
export const GET_NAVER_MEMBERINFO = `${BASE_PATH}/naver/get_member_status/`;

//// 유저 정보 체크 API
export const HeadersInfo = (
  ssoInfo: string,
  userID: string,
  userBirth: string,
  connectSite: string,
  type: string
) => {
  return {
    headers: {
      "Content-Type": type,
      Ssoinfo: ssoInfo,
      Userid: userID,
      Userbirth: userBirth,
      channelingType: connectSite
    }
  };
};

export interface IMember {
  data: {
    email: string;
    nickName: string | null;
    user_Serial: string;
    user_birthday: string;
    user_id: string;
  };
  result: number;
  sso_info: string;
}

export const GET_MEMBERINFO = (headers: {}) => {
  return VFUN({
    url: POST_GET_MEMBERINFO,
    method: "get",
    headers
  });
};

export const naverMemberStatus = (headers: {}, serviceCode: string) => {
  return VFUN({
    url: GET_NAVER_MEMBERINFO + `${serviceCode}`,
    method: "get",
    headers
  });
};

//// CombineMenu
export interface ISub_Menu {
  created_at: string;
  menu_code: string;
  target: string;
  target_url: string;
  title: string;
}

export interface IMenuData {
  menu_code: string;
  sub_menu: string;
  sub_menus: ISub_Menu[];
}

export interface ICombineMenu {
  result: number;
  data: IMenuData[];
}

export const getCombineMenu = (
  ssoInfo: string,
  userID: string,
  userBirth: string,
  connectSite: string,
  langCode: string
) =>
  axios
    .get(
      `${BASE_PATH}/vfun/combinemenus?lang=${langCode}`,
      HeadersInfo(ssoInfo, userID, userBirth, connectSite, "application/json")
    )
    .then((res) => res.data);

//// GCOIN
export interface IGCoin {
  result: number;
  data: {
    bonus_cash: number;
    real_cash: number;
    return_code: any;
    point: number;
  };
}

export const getGcoin = (
  service_code: string,
  ssoInfo: string,
  userID: string,
  userBirth: string,
  connectSite: string
) =>
  axios
    .get(
      `${BASE_PATH}/vfun/gcoin/balance/${service_code}`,
      HeadersInfo(ssoInfo, userID, userBirth, connectSite, "application/json")
    )
    .then((res) => res.data);

//// Languages
interface ILangData {
  lang: string;
  lang_code: string;
}

export interface ILang {
  result: number;
  data: ILangData[];
}

export const getLanguage = () =>
  axios.get(`${BASE_PATH}/vfun/support_languages`).then((res) => res.data);

// export const getLanguage = (service_code: string) =>
//   axios
//     .get(`${BASE_PATH}/vfun/support_languages/${service_code}`)
//     .then((res) => res.data);

//// Banner
// sideMenu 하단의 배너
interface IBannerData {
  idx: number;
  banner_name: string;
  banner_image_url: string;
  banner_hover_image_url: string;
  language: string;
  target: string;
  target_url: string;
  start_date: string;
  end_date: string;
}

export interface IBanner {
  result: number;
  data: IBannerData[];
}

export const getBanner = () =>
  axios.get(`${BASE_PATH}/vfun/combinemenu_banners`).then((res) => res.data);

interface ITBData {
  banner_image_url: string;
  end_date: string;
  start_date: string;
  language: string;
  target: string;
  target_url: string;
  text: {};
}

// 게시글 리스트 위 배너
export interface ITopBanner {
  data: ITBData[];
  result: number;
}

export const getTopBanner = () =>
  axios.get(`${BASE_PATH}/vfunlounges/banner`).then((res) => res.data);

//// LoungeInfo, 라운지 최상단 정보 API
interface ILoungeInfoData {
  service_code: string;
  top_background_image_url: string;
  top_thumb_image_url: string;
  youtube_id: string | null;
  genre: number;
  web_url: string;
  pre_regist_url: string | null;
  age: number;
  sns: string;
  show_flag: string;
  like_count: number;
  title: string;
}

export interface ILoungeInfo {
  result: number;
  msg: string;
  data: ILoungeInfoData;
  user_like_status: number;
}

export const getLoungeInfo = (
  service_code: string,
  ssoInfo: string,
  userID: string,
  userBirth: string,
  connectSite: string,
  lang: string
) =>
  axios
    .get(
      `${BASE_PATH}/vfunlounge/${service_code}?lang=${lang}`,
      HeadersInfo(ssoInfo, userID, userBirth, connectSite, "application/json")
    )
    .then((res) => res.data);

// PageCategory
interface CategoryData {
  admin_flag: number;
  idx: number;
  service_code: string;
  lang_code: string;
  title: string;
}

export interface ILoungeSectionList {
  result: number;
  msg: string;
  data: CategoryData[];
}

export const getLoungeSectionList = (service_code: string) =>
  axios
    .get(`${BASE_PATH}/vfunlounge/sections/${service_code}`)
    .then((res) => res.data);

//// 컨텐츠 Api
// notice slide
interface ISlide {
  idx: number;
  section: string;
  title: string;
  lang_code: string;
}

export interface INoticeSlideProps {
  result: number;
  data: ISlide[];
}

export const getNoticeSlide = (service_code: string, lang: string) =>
  axios
    .get(`${BASE_PATH}/vfunlounge/posts/${service_code}/top?lang=${lang}`)
    .then((res) => res.data);

// detailcontent
export interface DetailData {
  admin_flag: number;
  admin_icon: string;
  idx: number;
  service_code: string;
  section: number;
  language: string;
  title: string;
  nickname: string;
  content: string;
  images: null | string[];
  status: number;
  user_id: string;
  like_count: number;
  created_at: string;
  updated_at: string;
  user_ip: string;
  comments_count: number;
  user_like_status: number;
}

export interface IDetail {
  result: number;
  msg: string;
  data: DetailData;
}

export const getDetailContent = (
  service_code: string,
  title: string,
  idx: string,
  ssoInfo: string,
  userID: string,
  userBirth: string,
  connectSite: string
) =>
  axios
    .get(
      `${BASE_PATH}/vfunlounge/posts/${service_code}/${title}/${idx}`,
      HeadersInfo(ssoInfo, userID, userBirth, connectSite, "application/json")
    )
    .then((res) => res.data);

//// 댓글 관련 Api
export interface CommentData {
  idx: number;
  board_idx: number;
  comment_idx: number;
  comment: string;
  images: string;
  status: number;
  user_id: string;
  user_ip: string;
  created_at: string;
  updated_at: string;
  admin_flag: number;
  admin_icon: string;
}

interface Data {
  current_page: number;
  data: CommentData[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: null | string;
  path: string;
  per_page: number;
  prev_page_url: null | string;
  to: number;
  total: number;
}

export interface IComment {
  result: number;
  data: Data;
}

// commentApi
export const commentApi = (idx: string | undefined) =>
  `${BASE_PATH}/vfunlounge/comments/${idx}`;

// getComment
export const getComment = (idx: string) =>
  axios.get(commentApi(idx)).then((res) => res.data);

// 런처 로그인
export interface ILoginData {
  data: {
    birthday: string;
    check_email: string;
    email: string;
    member_type: string;
    service_code?: string;
    sso_info: string;
    sso_info_new: string;
    user_id: string;
  };
  result: number;
}

export const checkWebTokenApi = `${BASE_PATH}/auth/checkWebToken`;

export const getGrade = (ssoInfo: string, userID: string, userBirth: string) =>
  axios.get(
    `${BASE_PATH}/vfun/billingGrade`,
    HeadersInfo(ssoInfo, userID, userBirth, "", "application/json")
  );
